import React from 'react';
import ReactDOM from 'react-dom/client';

import reportWebVitals from './reportWebVitals';
import { App } from './App';

import './css';
import { randomCall, rewardedCalls } from './content';

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement,
);

const bridge = window.bridge;

bridge
    .initialize()
    .then(() => Promise.all(
        rewardedCalls.map(call => bridge.storage
            .get<boolean>(call.id)
            .then(watched => call.available = Boolean(watched)),
        ),
    ))
    .then(() => {
        bridge.advertisement.showInterstitial();

        bridge.remoteConfig.get().then(config => {
            if (config.maxFieldSize !== '0') {
                randomCall.available = true;
            }
        });

        if (bridge.platform.id === 'yandex') {
            bridge.platform.sdk.features.LoadingAPI.ready();
        }

        root.render(
            <React.StrictMode>
                <App />
            </React.StrictMode>,
        );
    });


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
